/* DON'T EDIT THIS FILE: edit original and run build again */ const onboardingTermsOfUseTitle =
  "CONDICIONES GENERALES DE APERTURA DE CUENTA COMITENTE";

export default onboardingTermsOfUseTitle;
